import {  Theme, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { LayoutGrid, LayoutGridItem } from 'app/layout/LayoutGrid';
import React from 'react';
import moment from 'moment';
import { IApproverType } from './ExceptionDetails/Controls/ApproverType';
import { AttachmentView } from './AttachmentView';
import { ExceptionWaiveSelection } from '../../../Store/PlacementEventDetails.selector';
import { useSelector } from 'react-redux';

const useStyles = makeStyles()((theme: Theme) =>
  ({
    header: {
      fontSize: '12px',
      color: '#555555',
      paddingBottom: '10px',
      fontWeight: 500,
    },
    notes: {
      height: '50px',
      overflowY: 'auto',
      width: '100%',
    },
  }));

export const ViewExceptionWaive = ({ credentialName }: { credentialName: string }) => {
  const { classes } = useStyles();
  const exceptionWaiveSel = useSelector(ExceptionWaiveSelection);

  return (
    <LayoutGrid direction="column" style={{ paddingTop: '20px' }}>
      <LayoutGridItem xs={12}>
        <LayoutGrid>
          <LayoutGridItem style={{ width: '25%' }}>
            <Typography className={classes.header}>{`Credential Name`}</Typography>
            <Typography>{credentialName}</Typography>
          </LayoutGridItem>
          <LayoutGridItem style={{ width: '25%' }}>
            <Typography className={classes.header}>{`Status`}</Typography>
            <Typography>{exceptionWaiveSel?.type ? exceptionWaiveSel.type : '-'}</Typography>
          </LayoutGridItem>
        </LayoutGrid>
      </LayoutGridItem>
      <LayoutGridItem xs={12}>
        <LayoutGrid>
          <LayoutGridItem style={{ width: '25%' }}>
            <Typography className={classes.header}>{`Approver Type`}</Typography>
            <Typography>
              {exceptionWaiveSel?.clientApproverName
                ? IApproverType.client
                : exceptionWaiveSel?.amnApproverName
                ? IApproverType.amn
                : '-'}
            </Typography>
          </LayoutGridItem>
          <LayoutGridItem style={{ width: '25%' }}>
            <Typography className={classes.header}>{`Client Approver Name`}</Typography>
            <Typography>
              {exceptionWaiveSel?.clientApproverName ? exceptionWaiveSel.clientApproverName : '-'}
            </Typography>
          </LayoutGridItem>
          <LayoutGridItem style={{ width: '25%' }}>
            <Typography className={classes.header}>{`Client Approver Title`}</Typography>
            <Typography>
              {exceptionWaiveSel?.clientApproverTitle ? exceptionWaiveSel.clientApproverTitle : '-'}
            </Typography>
          </LayoutGridItem>
        </LayoutGrid>
      </LayoutGridItem>
      <LayoutGridItem xs={12}>
        <LayoutGrid>
          <LayoutGridItem style={{ width: '25%' }}>
            <Typography className={classes.header}>{`Client Department`}</Typography>
            <Typography>{exceptionWaiveSel?.clientDepartment ? exceptionWaiveSel.clientDepartment : '-'}</Typography>
          </LayoutGridItem>
          <LayoutGridItem style={{ width: '25%' }}>
            <Typography className={classes.header}>{`AMN Approver Name`}</Typography>
            <Typography>{exceptionWaiveSel?.amnApproverName ? exceptionWaiveSel.amnApproverName : '-'}</Typography>
          </LayoutGridItem>
          <LayoutGridItem style={{ width: '25%' }}>
            <Typography className={classes.header}>{`AMN Approver Title`}</Typography>
            <Typography>{exceptionWaiveSel?.amnApproverTitle ? exceptionWaiveSel.amnApproverTitle : '-'}</Typography>
          </LayoutGridItem>
          {exceptionWaiveSel?.type === 'Exception' && (
            <LayoutGridItem style={{ width: '25%' }}>
              <Typography className={classes.header}>{`Expiration Date`}</Typography>
              <Typography>
                {exceptionWaiveSel?.expirationDate
                  ? moment(exceptionWaiveSel.expirationDate).format('MM/DD/YYYY')
                  : '-'}
              </Typography>
            </LayoutGridItem>
          )}
        </LayoutGrid>
      </LayoutGridItem>
      <LayoutGridItem xs={12}>
        <Typography className={classes.header}>{`Note`}</Typography>
        <div className={classes.notes}>
          <Typography>{exceptionWaiveSel?.notes ? exceptionWaiveSel.notes : '-'}</Typography>
        </div>
      </LayoutGridItem>
      <LayoutGridItem xs={12}>
        <Typography className={classes.header} style={{ paddingTop: '10px' }}>{`Attachments`}</Typography>
        <div>
          {exceptionWaiveSel && exceptionWaiveSel?.existingAttachments && (
            <AttachmentView attachments={exceptionWaiveSel?.existingAttachments} />
          )}
        </div>
      </LayoutGridItem>
    </LayoutGrid>
  );
};
